import { EntityRepository, Repository } from "typeorm";
import { IndentForm } from "../entity/packing-indent.entity";

@EntityRepository(IndentForm)
export class IndentFormRepository extends Repository<IndentForm> {

}